/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as CareersRouteImport } from './routes/careers'
import { Route as LaColaborativaRouteImport } from './routes/la-colaborativa'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SupportRouteImport } from './routes/support'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const CareersRoute = CareersRouteImport.update({
  id: '/careers',
  path: '/careers',
  getParentRoute: () => rootRouteImport,
} as any)
const LaColaborativaRoute = LaColaborativaRouteImport.update({
  id: '/la-colaborativa',
  path: '/la-colaborativa',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/careers': typeof CareersRoute
  '/la-colaborativa': typeof LaColaborativaRoute
  '/privacy': typeof PrivacyRoute
  '/support': typeof SupportRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/careers': typeof CareersRoute
  '/la-colaborativa': typeof LaColaborativaRoute
  '/privacy': typeof PrivacyRoute
  '/support': typeof SupportRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/careers': typeof CareersRoute
  '/la-colaborativa': typeof LaColaborativaRoute
  '/privacy': typeof PrivacyRoute
  '/support': typeof SupportRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    '/' | '/about' | '/careers' | '/la-colaborativa' | '/privacy' | '/support'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/about' | '/careers' | '/la-colaborativa' | '/privacy' | '/support'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/careers'
    | '/la-colaborativa'
    | '/privacy'
    | '/support'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  CareersRoute: typeof CareersRoute
  LaColaborativaRoute: typeof LaColaborativaRoute
  PrivacyRoute: typeof PrivacyRoute
  SupportRoute: typeof SupportRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/careers': {
      id: '/careers'
      path: '/careers'
      fullPath: '/careers'
      preLoaderRoute: typeof CareersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/la-colaborativa': {
      id: '/la-colaborativa'
      path: '/la-colaborativa'
      fullPath: '/la-colaborativa'
      preLoaderRoute: typeof LaColaborativaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  CareersRoute: CareersRoute,
  LaColaborativaRoute: LaColaborativaRoute,
  PrivacyRoute: PrivacyRoute,
  SupportRoute: SupportRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
